import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
import { isDeviceIOS } from 'js/utils/iosDetection';
import { isDesktop } from 'js/utils/deviceDetection';
import { trackPwaInstallEvent } from 'js/utils/tracking';

// import actions
import { toggleOnlineStatus } from 'js/store/app/App.actions';

// import selectors
import { getStartFrontend } from 'js/store/app/App.selectors';

// import components
import RouterMain from 'js/containers/router/Router.main';
import SectionNav from 'js/containers/section/Section.nav';
import Modal from 'js/containers/modal/Modal';
import PWAAndroidPrompt from './components/pwa/Pwa.android-prompt';
import IOSInstallPrompt from './components/pwa/Pwa.ios-prompt';
import Notification from 'js/containers/notification/Notification';
import { trackEvent } from './utils/tracking';

const App = () => {
  trackEvent('game_play', { timestamp: Date.now(), content_title: 'NotPlayButton' });
  window.addEventListener('beforeunload', () => {
    trackEvent('game_quit', { timestamp: Date.now() });
  });

  const dispatch = useDispatch();

  // Listen for online/offline events to update the app's online status in the Redux store
  React.useEffect(() => {
    const handleOnline = () => dispatch(toggleOnlineStatus(true));
    const handleOffline = () => dispatch(toggleOnlineStatus(false));

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Set the initial online status
    dispatch(toggleOnlineStatus(window.navigator.onLine));

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  React.useEffect(() => {
    trackPwaInstallEvent();
  }, []);

  const startFrontend = useSelector((state) => {
    return getStartFrontend(state);
  });

  const renderSite = () => {
    return (
      <HelmetProvider>
        <Notification />
        {isDesktop() !== 'desktop' ? isDeviceIOS() ? <IOSInstallPrompt /> : <PWAAndroidPrompt /> : null}
        <Modal />
        <RouterMain />
        <SectionNav />
      </HelmetProvider>
    );
  };

  return startFrontend ? renderSite() : <div className="container">Loading...</div>;
};

export default App;
